
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import SecurityProvider from './components/SecurityProvider';
import ConsentManager from './components/ConsentManager';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Candidates from './pages/Candidates';
import Contact from './pages/Contact';
import Jobs from './pages/Jobs';
import JobsEmbedded from './pages/JobsEmbedded';
import Careers from './pages/Careers';
import Insights from './pages/Insights';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import CookiePolicy from './pages/CookiePolicy';
import './App.css';

function App() {
  // INSIGHTS_ENABLED: Set to true to enable Insights route
  const INSIGHTS_ENABLED = false;

  return (
    <SecurityProvider>
      <ConsentManager>
        <Router>
          <div className="min-h-screen bg-neutral-50">
            <Header />
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/jobs/embedded" element={<JobsEmbedded />} />
                <Route path="/careers" element={<Careers />} />
                {INSIGHTS_ENABLED && (
                  <Route path="/insights" element={<Insights />} />
                )}
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookies" element={<CookiePolicy />} />
              </Routes>
            </motion.main>
            <Footer />
          </div>
        </Router>
      </ConsentManager>
    </SecurityProvider>
  );
}

export default App;
